module.exports = __webpack_public_path__ + "img/like.461e154c.svg";